<nz-spin [nzSpinning]="loading" [nzTip]="'Loading data...'">
<nz-card  [nzBordered]="false" style="max-width: 1000px; margin: auto;">
  <nz-descriptions nzTitle="Transaction Info" [nzColumn]="2" nzBordered>
    <nz-descriptions-item nzTitle="Transaction ID">{{ payment?.transaction_id }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Status">
      <nz-tag [nzColor]="getStatusColor(payment?.payment_status)">
        {{ payment?.status | uppercase }}
      </nz-tag>
    </nz-descriptions-item>
    <nz-descriptions-item nzTitle="Amount Paid">
      {{ payment?.amount_paid_selected_currency | currency:(payment?.paid_currency_name?.symbol || 'USD'):'symbol':'1.2-2' }}
    </nz-descriptions-item>
    <nz-descriptions-item nzTitle="Amount Paid(USD)">{{ payment?.amount_paid_usd | currency:'USD' }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Payment Date">{{ payment?.payment_date | date: 'dd-MM-yyyy' }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Method">{{ payment?.payment_method }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Submision">{{ 'QS' + payment?.submission + ' ' + payment?.vendor_details?.name}}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Invoice">{{ payment?.invoice_details?.invoice_number }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Recorded By">{{ payment?.created_by_name }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Modified By">{{ payment?.modified_by_name }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Created At">{{ payment?.created_at | date: 'dd-MM-yyyy' }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Modified At">{{ payment?.modified_at | date: 'dd-MM-yyyy' }}</nz-descriptions-item>
  </nz-descriptions>

  <nz-divider>Notes</nz-divider>
   <nz-descriptions nzTitle="Notes" [nzColumn]="2" nzBordered>
    <nz-descriptions-item nzTitle="Note">{{  payment?.notes || 'No notes available.' }}</nz-descriptions-item>
   </nz-descriptions>


  <nz-divider>Files</nz-divider>
  <nz-table
    [nzData]="payment?.file_details"
    [nzBordered]="true"
    [nzSize]="'small'"
    [nzShowPagination]="false"
  >
    <thead>
      <tr>
        <th>File Name</th>
        <th>Download</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let file of payment?.file_details">
        <td>{{ getFileName(file?.file_url) }}</td>
        <td>
          <!-- <a [href]="file?.file_url" target="_blank" nz-button nzType="link">
            <i nz-icon nzType="download"></i> Download
          </a> -->
           <a (click)="handleDownload(file?.file_url, getFileName(file?.file_url))" nz-button nzType="link">
              <i nz-icon nzType="download"></i> Download
            </a>
        </td>
      </tr>
    </tbody>
  </nz-table>

</nz-card>
</nz-spin>
